/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_DescriptionInputs */

const en_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

const fr_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const es_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripcion`)
};

const it_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione`)
};

const nl_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschrijving`)
};

const pl_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opis`)
};

const fi_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvaus`)
};

const da_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beskrivelse`)
};

const sv_resume_editor_description = /** @type {(inputs: Resume_Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beskrivning`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Resume_Editor_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_description = /** @type {((inputs?: Resume_Editor_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_description(inputs)
	if (locale === "fr") return fr_resume_editor_description(inputs)
	if (locale === "es") return es_resume_editor_description(inputs)
	if (locale === "it") return it_resume_editor_description(inputs)
	if (locale === "nl") return nl_resume_editor_description(inputs)
	if (locale === "pl") return pl_resume_editor_description(inputs)
	if (locale === "fi") return fi_resume_editor_description(inputs)
	if (locale === "da") return da_resume_editor_description(inputs)
	if (locale === "sv") return sv_resume_editor_description(inputs)
	return en_resume_editor_description(inputs)
});